let isMobileMediaQuery = window.matchMedia(
    "only screen and (max-width: 991px)"
);
let isMobile = isMobileMediaQuery.matches;
let mediaChangeHandler = e => {
    isMobile = e.matches;
    $("#nav-menu").toggleClass("desktop-hide", isMobile);
    if (!isMobile) {
        $('.nav-main-link').removeClass('hidden');
    }
};
if (!isMobileMediaQuery.addEventListener && isMobileMediaQuery.addListener) {
    isMobileMediaQuery.addListener(mediaChangeHandler);
} else {
    isMobileMediaQuery.addEventListener("change", mediaChangeHandler);
}

$(document).on("click", "#btn-mobile-nav", function(event) {
    if (isMobile) {
        // Toggle the button class names
        $("#btn-mobile-nav .btn-mobile-nav-line").toggleClass("hidden");
        $("#btn-mobile-nav .btn-mobile-nav-cross").toggleClass("hidden");
        // Open the nav
        $("#nav-menu").toggleClass("hidden");
    }
});
$(document).on("click", "#nav-menu a.nav-submenu-link", function(event) {
    if (isMobile) {
        $(".nav-links").addClass("hidden");
        $(this)
            .closest(".nav-links")
            .find('.nav-links-submenu')
            .addClass('hidden');
        $(this)
            .closest(".nav-links")
            .removeClass("hidden")
            .addClass("open");
        $(this)
            .next(".nav-links-submenu")
            .removeClass("hidden");
    }
});
$(document).on("click", ".nav-links.open a.nav-submenu-link", function(event) {
    if (isMobile) {
        $(".nav-links").removeClass("hidden");
        $(this)
            .closest(".nav-links")
            .removeClass("open");
        $(".nav-links-submenu").addClass("hidden");
    }
});

$(document).on("mouseover", "#nav-menu a.nav-submenu-link", function(event) {
    if (!isMobile) {
        
        $(".nav-links-submenu").addClass("hidden");
        $(".nav-links-sub-submenu .nav-links-submenu").removeClass("hidden");
        $(this)
            .next(".nav-links-submenu")
            .removeClass("hidden");
    }
});

$(document).on("mouseleave", "header", function(event) {
    if (!isMobile) {
        $(".nav-links-submenu").addClass("hidden");
    }
});

$(document).on(
    "click",
    ".nav-links-sub-submenu a.nav-sub-submenu-link",
    function(event) {
        if (isMobile) {
            let link = $(event.currentTarget);
            let subMenu = link.next(".nav-links-submenu");
            let navLinksColumns = link.closest(".nav-links-columns");
            let subSubMenu = link.closest('.nav-links-sub-submenu');
            let allSubSubMenus = $('.nav-links-sub-submenu');
            let allSubMenus = $('.nav-links-submenu');
            allSubSubMenus.removeClass('open');
            navLinksColumns.find('.nav-links-submenu').addClass('hidden');
            subSubMenu.addClass('open');
            subMenu.closest('.nav-links-sub-submenu').addClass('open');
            console.log('Sub menu - sub menu link click', link, subMenu);
            subMenu.removeClass('hidden');
        }
    }
);
